import type { SelectedClient } from '@/entities/client';
import { useSheetStore } from '@/shared/stores/sheet-store';

// A plain function rather than a hook so it matches the profile summary's edit-profile action
// directly — see `open-client-details-sheet.ts` for the same shape.
export function openEditClientProfileSheet(client: SelectedClient) {
    useSheetStore.getState().openSheet({
        type: 'clients/edit-profile',
        label: 'Profile',
        data: { id: client.id, name: client.name },
    });
}
